import css from 'styled-jsx/css';

export default css`
  .aidify-container {
    background: linear-gradient(to right, #eef2ff, #fff, #eef2ff);
    padding: 40px 15px;
  }
  .aidify-container h3 {
    color: var(--black);
  }
  .aidify-subtitle {
    color: var(--grey-lighter);
    margin-top: 10px;
    align-self: center;
    max-width: 730px;
    line-height: 24px;
  }
  .aidify-link {
    text-decoration: underline;
    cursor: pointer;
    color: var(--black);
    font-weight: 700;
  }
  .bold {
    font-weight: 700;
    color: var(--black);
  }
`;
